import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { DraftCommitmentService } from '../../../coaching-base/draft-commitment.service';
import { Dependencies } from '../../../store';
import { pluck } from '../../../store.decorator';
import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import {
    AddCommitmentNotes,
    addCommitmentNotesResult,
} from './add-commitment-notes.action';

export const addCommitmentNotesEpic = (
    action: ActionsObservable<PayloadAction<ActionType, AddCommitmentNotes>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<any> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TD__ADD_COMMITMENT_NOTES),
        mergeMap((act: PayloadAction<ActionType, AddCommitmentNotes>) => {
            const rootState = pluck<TranscriptDialogState>(
                state.value,
                act.storePath,
            );
            const draftCommitmentService =
                deps.injector.get<DraftCommitmentService>(
                    DraftCommitmentService,
                );

            const data = {
                performerId: act.payload.performerId,
                coachId: act.payload.coachId,
                behaviourId: rootState.cmtNotesFocus?.behaviour?.id,
                subBehaviourId: rootState.cmtNotesFocus?.subBehaviour?.id,
                notes: act.payload.notes,
                timeZoneOffset: new Date().getTimezoneOffset(),
            };

            return of(null)
                .pipe(
                    draftCommitmentService.addNotes(() => ({
                        data,
                    })),
                )
                .pipe(
                    map((ret) => {
                        return addCommitmentNotesResult(
                            {
                                ...act.payload,
                                commitmentInfo: ret,
                            },
                            act.storePath,
                        );
                    }),
                    catchError((err) => {
                        console.log(err);
                        return of(null);
                    }),
                );
        }),
    );
